import { createSlice } from '@reduxjs/toolkit'

export const CreateProjectSourceLanguageSlice = createSlice(
  {
  name: 'source_language_for_project_creation',
  initialState: {
    value: {},
  },
  reducers: {
    updateSourceLanguage: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateSourceLanguage } = CreateProjectSourceLanguageSlice.actions

export default CreateProjectSourceLanguageSlice.reducer